export const mailTemplates: TableModule = {
    name: 'mailTemplates',
    route: 'spa.system.mailTemplates',
    defaultOrder: {
        column: 'id',
        direction: 'asc'
    },
    columns: [
        {
            name: 'name',
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: 'visibility',
            sortable: true,
            truncate: false,
            sortBy: 'mail_templates.organisation_id',
        },
        {
            name: 'created_at',
            sortable: true,
            width: 'w-[150px]',
            breakpoint: 'lg'
        },
        {
            name: 'status',
            truncate: false,
            mobile: true,
            width: 'w-[100px]'
        },
    ],
    filters: [
        {
            name: 'id',
            column: 'mail_templates.id',
            type: 'numeric'
        },
        {
            name: 'type',
            column: 'mail_templates.type',
            type: 'select',
            reduced: true,
            options: () => [
                { value: 'leaders.invite', label: useNuxtApp().$i18n.t('mailTemplates.types.leaders.invite') },
                { value: 'participants.pass.overdue', label: useNuxtApp().$i18n.t('mailTemplates.types.participants.pass.overdue') },
                { value: 'participants.pass.reminder', label: useNuxtApp().$i18n.t('mailTemplates.types.participants.pass.reminder') },
                { value: 'participants.pass.send', label: useNuxtApp().$i18n.t('mailTemplates.types.participants.pass.send') },
                { value: 'participants.pass.signed', label: useNuxtApp().$i18n.t('mailTemplates.types.participants.pass.signed') },
            ]
        },
        {
            name: 'name',
            column: 'mail_templates.name',
            type: 'string',
            reduced: true
        },
        {
            name: 'by_organisation',
            column: 'mail_templates.organisation_id',
            type: 'exists',
        },
        {
            name: 'created_at',
            column: 'mail_templates.created_at',
            type: 'date'
        }
    ],
    quickFilters: [
        {
            name: 'qf_onlyGlobal',
            column: 'mail_templates.organisation_id',
            operator: 'exists',
            value: '0'
        },
        {
            name: 'qf_onlyByOrganisation',
            column: 'mail_templates.organisation_id',
            operator: 'exists',
            value: '1'
        }
    ],
}